import React from 'react'
import s from '../index.module.css'
import { Foot } from '../../../../svg/foot'
import { FlowerPot } from '../../../../svg/flower_pot'
import { Recycle } from '../../../../svg/recycle'
import { World } from '../../../../svg/world'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const settings = {
  dots: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  rows: 2,
  autoplay: false,
  autoplaySpeed: 20000,
  initialSlide: 0,
  centerPadding: '0px',
  appendDots: dots => <ul style={{ bottom: '-35px' }}>{dots}</ul>,
  customPaging: i => <span className="ft-slick__dots--custom"></span>,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        rows: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        dots: true,
        centerMode: false,
        infinite: false,
        variableWidth: true,
        centerPadding: '-60px',
        className: 'slick-partial-imagen',
        rows: 1,
      },
    },
  ],
}
const cardData = [
  {
    title: 'Aprendo y tomo acción',
    subTitle: '',
    image: <Foot fill="#00CCCC" className={'tw-mb-4'} width={40} height={40} />,
    text:
      'Le enseñamos a todos nuestros colaboradores formas sencillas de reducir su huella de carbono, tanto dentro de la empresa, como en sus hogares.',
  },
  {
    title: 'Recicla para ayudar',
    subTitle: '',
    image: (
      <Recycle fill="#00CCCC" className={'tw-mb-4'} height={40} width={40} />
    ),
    text:
      'Mediante esta campaña reciclamos las botellas de plástico de nuestros colaboradores para después convertirlas en mantas que sirvan de abrigo para los adultos mayores en situación de pobreza.',
  },
  {
    title: 'Reciclatón - Cumple tu papel',
    subTitle: 'En convenio con FUNADES',
    image: (
      <FlowerPot fill="#00CCCC" className={'tw-mb-4'} height={40} width={40} />
    ),
    text:
      'Juntamos papel en desuso de todas nuestras oficinas e incentivamos a nuestros colaboradores a que hagan lo propio en sus hogares para poder ayudar a la educación de más niños.',
  },
  {
    title: 'Ecoeficiencia',
    subTitle: '',
    image: (
      <World fill="#00CCCC" className={'tw-mb-4'} height={40} width={40} />
    ),
    text:
      'Buscamos reducir 2 de los impactos de huella de carbono tomando estas medidas: Plan disminución del consumo del papel en impresiones y copias. Plan reducción del consumo de energía con el uso eficiente de luz natural y cambio a luminarias sostenibles.',
  },
]

const Initiative = () => (
  <div>
    <Slider {...settings}>
      {cardData.map(item => (
        <div
          className={`tw-p-3 tw-p-4@lg tw-mb-6 tw-mb-0@lg tw-mr-0@lg`}
          key={item.title}
        >
          <div
            className={`${s.itemBox1} brad-4 shadow bg-white tw-p-6 tw-p-8@lg`}
          >
            {item.image}
            <p className="font-family-secondary fw-4 tw-f-14 left tw-mb-2">
              {item.subTitle}
            </p>
            <h3 className="font-family-secondary c-gray--4 fw-7 tw-f-20 tw-f-20@lg tw-mb-4 tw-mt-0">
              {item.title}
            </h3>
            <div className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg">
              {item.text}
            </div>
          </div>
        </div>
      ))}
    </Slider>
  </div>
)

export default Initiative
